var map = {
	"./recommend-list-1.png": "0W3B",
	"./recommend-list-10.png": "xxjW",
	"./recommend-list-11.png": "jFat",
	"./recommend-list-12.png": "tBIc",
	"./recommend-list-2.png": "A+pT",
	"./recommend-list-3.png": "djtr",
	"./recommend-list-4.png": "Mn/n",
	"./recommend-list-5.png": "i9sf",
	"./recommend-list-6.png": "ybwR",
	"./recommend-list-7.png": "DyhA",
	"./recommend-list-8.png": "Mi3e",
	"./recommend-list-9.png": "55zf"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "rk8V";


//////////////////
// WEBPACK FOOTER
// ./src/img/main ^\.\/recommend\-list\-.*\.png$
// module id = rk8V
// module chunks = 1